import React from 'react';
import * as PropTypes from "prop-types";
import '../../resources/css/application.css';

const ConfirmationDialog = (props) => {

    const {open, onClick, onClose, title, message, boldMessage, submitButtonText} = props;

    return (
      <div>
          {open &&
          <div className="modal">
              <div className="modal-dialog modal-md modal-dialog-centered">
                  <div className="modal-content">
                      <div className="modal-header justify-content-center mb-5">
                          <h3 className="headline-3 text-center">{title}</h3>
                      </div>
                      <div className="modal-body justify-content-center mb-5">
                          <p className="text-center">{message} <strong>{boldMessage}</strong></p>
                      </div>
                      <div className="modal-footer justify-content-center">
                          <button type="button" data-dismiss="modal" aria-label="Close"
                                  className="btn btn--secondary btn--xs-full-width"
                                  onClick={() => onClose()}>Odustani
                          </button>
                          <button type="button" aria-label="Close"
                                  className="btn btn--primary-red btn--xs-full-width"
                                  onClick={() => onClick()}>{submitButtonText}
                          </button>
                      </div>
                  </div>
              </div>
          </div>
          }
      </div>
    );
};

ConfirmationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    message: PropTypes.string,
    boldMessage: PropTypes.string,
    submitButtonText: PropTypes.string
};

export default ConfirmationDialog;